let $ = require("jquery");

$.fn.extend({
  loading: function (enable) {
    return this.each(function () {
      let $this = $(this);
      if (enable || enable === undefined) {
        let width = $this.width();
        $this.data("old-body", $this.html());
        $this.html('<i class="fa fa-circle-o-notch fa-spin" />');
        $this.width(width);
      } else {
        $this.html($this.data("old-body"));
      }
    });
  },
});
